/**
 * It's not a bug, is a feature! :D
 * You must use a hook instead
 */
function HookUseNotificationManager() {
  console.warn('Not meant to be used like this') // eslint-disable-line no-console
  return <div>Must use named import to use hooks</div>
}

HookUseNotificationManager.displayName = 'HookUseNotificationManager'

export default HookUseNotificationManager
